import React from "react";
import { Route, Routes } from "react-router-dom";
import BinarySystem from "./Pages/BinarySystem/BinarySystem";
import BonusSystem from "./Pages/BonusSystem/BonusSystem";
import DashboardNew from "./Pages/Dashboard/DashboardNew";
import Finance from "./Pages/Finance/Finance";
import MyTeam from "./Pages/MyTeam/MyTeam";
import News from "./Pages/News/News";
import Plans from "./Pages/Plans/Plans";
import Support from "./Pages/Support/Support";
import Profile from "./Pages/Profile/Profile";
import Transactions from "./Pages/Transactions/Transactions";
import DirectTeam from "./Pages/DirectTeam/DirectTeam";
import GenerationTeam from "./Pages/GenerationTeam/GenerationTeam";
import Withdraw from "./Pages/Withdraw/Withdraw";
import Blog from "./Pages/Blog/Blog";
import WithdrawalHistory from "./Pages/WithdrawalHistory/WithdrawalHistory";
import NotificationPage from "./Pages/NotificationPage/NotificationPage";
import Market from "./Pages/Market/Market";
import ActivationHistory from "./Pages/ActivationHistory/ActivationHistory";
import AllCapping from "./Pages/AllCapping/AllCapping";
import SlotDetailsPage from "./Pages/Dashboard/SlotDetailsPage";
import EditAccount from "./Pages/EditAccount/EditAccount";
import Claim from "./Pages/Claim/Claim";
import StakingPage from "./Pages/StakingPage/StakingPage";
import PaymentWIthAPI from "./Pages/StakingPage/PaymentWIthAPI";
import SellToken from "./Pages/SellToken/SellToken";
import WalletTransfer from "./Pages/WalletTransfer/WalletTransfer";
import Incomes from "./Pages/Incomes/Incomes";
import Genealogy from "./Pages/Genealogy/Genealogy";
import Fund from "./Pages/Fund/Fund";
import PaymentWithUPI from "./Pages/PaymentWithUPI/PaymentWithUPI";
import UploadPaymentProof from "./Pages/UploadPaymentProof/UploadPaymentProof";
import Welcome from "./Pages/Welcome/Welcome";
import KYC from "./Pages/KYC/KYC";
import Bonanza from "./Pages/Bonanza/Bonanza";
import WaitingPage from "./Pages/WaitingPage/WaitingPage";
import LegBusiness from "./Pages/LegBusiness/LegBusiness";
import Tickets from "./Pages/Support/Tickets";
import UtilityWallet from "./Pages/UtilityWallet/UtilityWallet";
import BusinessReport from "./Pages/BusinessReport/BusinessReport";
import TransferAirdrop from "./Pages/TransferAirdrop/TransferAirdrop";
// import AddFund from "./Pages/AddFund/AddFund";
import UplineBonus from "./Pages/UplineBonus/UplineBonus";
// import FundTransferToGame from "./Pages/FundTransferToGame/FundTransferToGame";
import OrderHistory from "./Pages/Plans/Order";
import PaymentWithCrypto from "./Pages/PaymentWithCrypto/PaymentWithCrypto";
import FundTransfer from "./Pages/FundPages/FundTransfer/FundTransfer";
import OverallFundHistory from "./Pages/FundPages/FundRequest/OverallFundHistory";
import Packages from "./Pages/Plans/Package";
import Ranks from "./Pages/Ranks/Ranks";
import SwappingHistory from "./Pages/Swap/SwappingHistory";
import PrincipalWithdrawalHistory from "./Pages/Plans/PrincipalWithdrawalHistory";
import PaymentTransactionHistory from "./Pages/TransactionHistory/TransactionHistory";
import FundConvert from "./Pages/FundPages/FundConvert/FundConvert";
import Subscribe from "./Components/Subscribe/Subscribe";
const NavPages = () => {
  return (
    <Routes>
      <Route exact={true} path="/*" element={<DashboardNew />}></Route>
      <Route exact={true} path="/finance" element={<Finance />}></Route>
      <Route exact={true} path="/my_team" element={<MyTeam />}></Route>

      <Route
        exact={true}
        path="/bonus_system"
        element={<BonusSystem />}
      ></Route>
      <Route exact={true} path="/plans" element={<Plans />}></Route>
      <Route exact={true} path="/package" element={<Packages />}></Route>
      <Route exact={true} path="/ranks" element={<Ranks />}></Route>
      {/* <Route exact={true} path="/add_fund" element={<AddFund />}></Route> */}
      <Route
        exact={true}
        path="/wallet_transfer"
        element={<WalletTransfer />}
      ></Route>
      <Route exact={true} path="/plans/stake" element={<StakingPage />}></Route>
      <Route exact={true} path="/news" element={<News />}></Route>
      <Route exact={true} path="/support" element={<Support />}></Route>
      <Route
        exact={true}
        path="/binary_system"
        element={<BinarySystem />}
      ></Route>
      <Route exact={true} path="/profile" element={<Profile />}></Route>
      <Route exact={true} path="/kyc" element={<KYC />}></Route>
      <Route exact={true} path="/bonanza" element={<Bonanza />}></Route>
      <Route exact={true} path="/transfer_airdrop" element={<TransferAirdrop />}></Route>

      <Route exact={true} path="/incomes" element={<Incomes />}></Route>
      {/* <Route
        exact={true}
        path="/transactions"
        element={<Transactions />}
      ></Route> */}
      <Route exact={true} path="/direct_team" element={<DirectTeam />}></Route>
      <Route exact={true} path="/claim" element={<Claim />}></Route>
      <Route
        exact={true}
        path="/generation_team"
        element={<GenerationTeam />}
      ></Route>

      {/* <Route
        exact={true}
        path="/development_bonus"
        element={<GameDevelopmentBonus />}
      ></Route> */}
      <Route exact={true} path="/withdraw" element={<Withdraw />}></Route>
      <Route exact={true} path="/set_account" element={<EditAccount />}></Route>
      {/* <Route exact={true} path="/fund" element={<Fund />}></Route> */}

      <Route
        exact={true}
        path="/withdrawal_history"
        element={<WithdrawalHistory />}
      ></Route>
      <Route
        exact={true}
        path="/notification"
        element={<NotificationPage />}
      ></Route>
      <Route exact={true} path="/market" element={<Market />}></Route>
      {/* <Route
        exact={true}
        path="/activation_history"
        element={<ActivationHistory />}
      ></Route> */}
      <Route
        exact={true}
        path="/staking_details"
        element={<AllCapping />}
      ></Route>
      <Route exact={true} path="/slot" element={<SlotDetailsPage />}></Route>
      <Route exact={true} path="/sell_token" element={<SellToken />}></Route>
      <Route exact={true} path="/genealogy" element={<Genealogy />}></Route>
      <Route
        exact={true}
        path="/plans/stake/payment"
        element={<PaymentWIthAPI />}
      ></Route>
      <Route
        exact={true}
        path="/payment-upi"
        element={<PaymentWithUPI />}
      ></Route>
      <Route
        exact={true}
        path="/payment-proof"
        element={<UploadPaymentProof />}
      />
      <Route
        exact={true}
        path="/profile/welcome-letter"
        element={<Welcome />}
      ></Route>
      <Route
        exact={true}
        path="/floxyPayment"
        element={<WaitingPage />}
      ></Route>
      <Route
        exact={true}
        path="/leg_business"
        element={<LegBusiness />}
      ></Route>
      <Route exact={true} path="/tickets" element={<Tickets />}></Route>
      <Route
        exact={true}
        path="/utility_wallet"
        element={<UtilityWallet />}
      ></Route>
      <Route
        exact={true}
        path="/business_report"
        element={<BusinessReport />}
      ></Route>
      <Route
        exact={true}
        path="/upline_bonus"
        element={<UplineBonus />}
      ></Route>
      {/* <Route
        exact={true}
        path="/fund_transfer_to_game"
        element={<FundTransferToGame />}
      ></Route> */}
      <Route
        exact={true}
        path="/order_history"
        element={<OrderHistory />}
      ></Route>
      {/* <Route
        exact={true}
        path="/overall_fund_history"
        element={<OverallFundHistory />}
      ></Route> */}
      <Route exact={true} path="/deposit" element={<PaymentWithCrypto />} />
      {/* <Route exact={true} path="/Fundtransfer" element={<FundTransfer />} /> */}
      <Route exact={true} path="/fund" element={<FundConvert />} />
      {/* <Route exact={true} path="/left_team" element={<LeftTeam />}></Route>
      <Route exact={true} path="/right_team" element={<RightTeam />}></Route> */}
      {/* <Route exact={true} path="/binary_tree" element={<BinaryTree />}></Route>
      <Route exact={true} path="/binary_team" element={<BinaryTeam />}></Route> */}
      <Route
        exact={true}
        path="/transaction_history"
        element={<PaymentTransactionHistory />}
      />
      <Route
        exact={true}
        path="/swapping_history"
        element={<SwappingHistory />}
      />
      <Route
        exact={true}
        path="/overall_fund_history"
        element={<OverallFundHistory />}
      />
      <Route
        exact={true}
        path="/principal_history"
        element={<PrincipalWithdrawalHistory />}
      />
      <Route
        exact={true}
        path="/subscribe"
        element={<Subscribe />}
      />
    </Routes>
  );
};

export default NavPages;
